var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500 990C229.8 990 10 770.2 10 500S229.8 10 500 10s490 219.8 490 490-219.8 490-490 490zm0-933.3C255.5 56.7 56.7 255.5 56.7 500S255.6 943.3 500 943.3c244.5 0 443.3-198.9 443.3-443.3 0-244.5-198.8-443.3-443.3-443.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M362.1 287.9 725 500 362.1 699.7V287.9z"
  })));
};
export default SvgIcon;